import type { oz } from '@weft/utils';
import { ProductVariantInputSchema } from '../../product-variant-input-schema';
import { SubscriptionPricingInputSchema } from './subscription-pricing-input-schema';

export const SubscriptionProductVariantInputSchema = ProductVariantInputSchema
  .partial()
  .extend({
    pricing: SubscriptionPricingInputSchema,
  })
  .openapi('RecurringProductVariantInput');

export type RecurringProductVariantInput = oz.infer<typeof SubscriptionProductVariantInputSchema>;